
<template>
  <div class="index">
    <div class="index-con">
      <div class="login-con">
        <div class="index-title">创建账户</div>
        <div class="login-cons">
          <div class="login-center">
            <div class="login-text" style="margin-bottom: 30px;">
              已经有帐户了吗?
              <span class="text-blue cup" @click="toLogin">请登录</span>
            </div>
            <div class="login-list">
              <p class="login-title">邮箱*</p>
              <input type="text" v-model="email" />
            </div>
            <div class="login-list df">
              <p class="login-title">头衔*</p>
              <el-radio-group v-model="mytitle">
                <el-radio label="教授">教授</el-radio>
                <el-radio label="博士">博士</el-radio>
                <el-radio label="先生">先生</el-radio>
                <el-radio label="女士">女士</el-radio>
                <el-radio label="太太">太太</el-radio>
              </el-radio-group>
            </div>
            <div class="login-list">
              <p class="login-title">名字*</p>
              <input type="text" v-model="firstname" />
            </div>
            <div class="login-list">
              <p class="login-title">姓*</p>
              <input type="text" v-model="lastname" />
            </div>
            <div class="login-list">
              <p class="login-title">密码*</p>
              <input type="password" v-model="password" placeholder="密码长度需要为6-15" />
            </div>
            <div class="login-list">
              <p class="login-title">重新输入密码*</p>
              <input type="password" v-model="twoPsd" />
            </div>
            <!-- <div class="login-list">
              <p class="login-title">Name*</p>
              <input type="text" v-model="name" />
            </div> 
            <div class="login-list">
              <p class="login-title">国家*</p>
              <input type="text" v-model="country" />
            </！div>-->
            <div class="login-list">
              <p class="login-title">工作单位*</p>
              <input type="text" v-model="affiliation" />
            </div>
            <div class="login-list">
              <p class="login-title">住址*</p>
              <input type="text" v-model="address" />
            </div>
            <div class="login-list">
              <p class="login-title">手机*</p>
              <input type="text" v-model="tel" />
            </div>
            <!-- <div class="login-list">
              <p class="login-title">About*</p>
              <textarea
                placeholder="Special instructions"
                v-model="about"
                cols="90"
                rows="4"
                maxlength="1000000"
              ></textarea>
            </div> -->

            <div class="login-list">
              <p class="login-title">验证码* (区分大小写)</p>
              <div class="d-flex">
                <input type="text" v-model="code" />
                <ValidCode @input="createValidCode" />
              </div>
            </div>
            <div class="login-btn" @click="regFn">登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidCode from "./code.vue";

export default {
  components: {
    ValidCode,
  },
  data() {
    return {
      validCode: "",
      radio: 3,
      email: "", // "282@qq.com",
      mytitle: "Dr.", // "Dr.",
      firstname: "", // "aaa",
      lastname: "", // "bbb",
      password: "", // "cccddd",
      twoPsd: "", // "cccddd",
      code: "", // "1234",
      myCode: "", // "1234",

      name: "", // "aaa",
      country: "", // "bbb",
      affiliation: "", // "cccddd",
      address: "", // "cccddd",
      fax: "", // "1234",
      about: "", // "1234",
      tel: "",
    };
  },
  mounted() {
    console.log(this.mytitle, '----=-=-=')
  },
  methods: {
    loginzh() { },
    createValidCode(data) {
      this.validCode = data;
      console.log(this.validCode, "-=-=-=");
    },
    toLogin() {
      this.$router.push("/loginzh");
    },
    regFn() {
      console.log(
        this.code.toLowerCase(),
        this.validCode.toLowerCase(),
        this.code.toLowerCase() != this.validCode.toLowerCase()
      );
      if (!this.email) {
        this.$message.error("Please enter your email address");
        return;
      }
      if (!this.firstname) {
        this.$message.error("Please enter your Firstname");
        return;
      }
      if (!this.lastname) {
        this.$message.error("Please enter your Lastname");
        return;
      }
      if (!this.password) {
        this.$message.error("Please enter your Password");
        return;
      }
      if (!this.twoPsd) {
        this.$message.error("Please enter your Retype Password");
        return;
      }
      if (this.twoPsd != this.password) {
        this.$message.error("Password inconsistency");
        return;
      }
      if (this.password.length < 6 || this.password.length > 15) {
        this.$message.error("The password length needs to be 6-15");
        return;
      }
      if (!this.code) {
        this.$message.error("Please enter Verfication Code");
        return;
      }
      if (this.code.toLowerCase() != this.validCode.toLowerCase()) {
        this.$message.error("Verfication Code inconsistency");
        return;
      }
      var params = {
        Firstname: this.firstname,
        email: this.email,
        Lastname: this.lastname,
        password: this.password,
        mytitle: this.mytitle,
        ifcn: 0,
        name: this.name,
        country: this.country,
        affiliation: this.affiliation,
        address: this.address,
        fax: this.fax,
        tel: this.tel,
        about: this.about,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.register(params).then((res) => {
        console.log(res);
        loading.close();
        if (res.code == "200") {
          that.$message.success("Registration successful");
          var con = res.data[0];
          localStorage.setItem("Firstname", con.Firstname);
          localStorage.setItem("Lastname", con.Lastname);
          localStorage.setItem("email", con.email);
          localStorage.setItem("mytitle", con.mytitle);
          localStorage.setItem("token", con.token);
          localStorage.setItem("visitor_id", con.visitor_id);
          localStorage.setItem("ifcn", 0);
          setTimeout(() => {
            that.$router.push("/loginThen");
          }, 500);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.index-con {
  width: 1200px;
  margin: 0 auto;
}

.login-con {
  margin-top: 20px;
}

.index-title {
  font-size: 18px;
  font-weight: 500;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.login-con {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}

.login-cons {
  padding: 90px 20px 20px;
  box-sizing: border-box;
}

.df {
  display: flex;
  align-items: center;
}

.df .login-title {
  margin-right: 20px;
}

.login-center {
  width: 70%;
  margin: 0 auto;
}

.login-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.login-list {
  margin-bottom: 20px;
}

.login-list input {
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  color: #555;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.d-flex {
  display: flex;
}

.d-flex input {
  flex: 1;
  width: auto;
  margin-right: 20px;
}

.login-btn {
  color: #fff;
  background-color: #428bca;
  border: 1px solid #357ebd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
}

.login-text {
  margin-bottom: 15px;
}

.text-blue {
  color: #28d6ec;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .login-tip {
    font-size: 14px;
    text-indent: 10px;
  }

  .login-list input {
    width: 100%;
  }

  .info-small-title {
    height: auto;
  }

  .login-center {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/registerzh.vue